import { Box, Flex, Text } from '@approvalmax/ui/src/components';
import { XeroIcon } from 'modules/sprites';
import { memo } from 'react';
import { convertBillingAddressToString } from 'shared/helpers';

import { ContactInfoProps } from './ContactInfo.types';

export const ContactInfo = memo<ContactInfoProps>((props) => {
    const { contact } = props;

    return (
        <Box color='midnight30' spacing='8' radius='small'>
            <Flex alignItems='center' spacing='8'>
                <XeroIcon />

                <Flex direction='column' spacing='4'>
                    <Text font='label' fontSize='medium' fontWeight='medium'>
                        {contact.name}
                    </Text>

                    {contact.billingAddress && (
                        <Text font='label' fontSize='small' fontWeight='regular' color='midnight70'>
                            {convertBillingAddressToString(contact.billingAddress, ', ')}
                        </Text>
                    )}
                </Flex>
            </Flex>
        </Box>
    );
});

ContactInfo.displayName = 'ContactInfo';
